<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_v"></a><strong>Contents</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/frontmatter1">Acknowledgments</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/frontmatter2">A Note about Transcription of the Documents</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/frontmatter3">Glossary</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/frontmatter4">Introduction: The Road to Venona</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/chapter1">1: Venona and the Cold War</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/chapter2">2: Breaking the Code</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/chapter3">3: The American Communist Party Underground</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter4" title="Link target outside of Sample">4: The Golos-Bentley Network</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter5" title="Link target outside of Sample">5: Friends in High Places</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter6" title="Link target outside of Sample">6: Military Espionage</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter7" title="Link target outside of Sample">7: Spies in the U.S. Government</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter8" title="Link target outside of Sample">8: Fellowcountrymen</span></p>
<p class="toc"><a id="page_vi"></a><span class="nounder" href="#/xhtml/chapter9" title="Link target outside of Sample">9: Hunting Stalin’s Enemies on American Soil</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter10" title="Link target outside of Sample">10: Industrial and Atomic Espionage</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter11" title="Link target outside of Sample">11: Soviet Espionage and American History</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/backmatter1" title="Link target outside of Sample">APPENDIX A: Source Venona: Americans and U.S. Residents Who Had Covert Relationships with Soviet Intelligence Agencies</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/backmatter2" title="Link target outside of Sample">APPENDIX B: Americans and U.S. Residents Who Had Covert Relationships with Soviet Intelligence Agencies but Were Not Identified in the Venona Cables</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/backmatter3" title="Link target outside of Sample">APPENDIX C: Foreigners Temporarily in the United States Who Had Covert Relationships with Soviet Intelligence Agencies</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/backmatter4" title="Link target outside of Sample">APPENDIX D: Americans and U.S. Residents Targeted as Potential Sources by Soviet Intelligence Agencies</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/backmatter5" title="Link target outside of Sample">APPENDIX E: Biographical Sketches of Leading KGB Officers Involved in Soviet Espionage in the United States</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/backmatter6" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/backmatter7" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?25fe5104